//在这个文件中根路由 / 必须定义，children可自定义
const _import = require("../_import_" + process.env.NODE_ENV);

const routes = [
  {
    path: "/",
    name: "Login",
    component: _import("Login"),
    redirect: "/home",
    meta: {
      parent: 1, //是否是菜单0-否，1-是
    },
    children: [
      {
        path: "/home",
        name: "Home",
        component: _import("MainShouYe"),
        meta: {
          menuName: '首页',
          isIndex:1 //是否是菜单页
        },
      },
      {
        path: "/workDynamic",
        name: "workDynamic",
        component: _import("workDynamic/index"),
        meta: {
          menuName: '工作动态',
          isIndex:1 //是否是菜单页
        },
      },
      {
        path: "/construction",
        name: "construction",
        component: _import("constructionWork/index"),
        meta: {
          menuName: '党建工作',
          isIndex:1 //是否是菜单页
        },
      },
      {
        path: "/projectIntro",
        name: "projectIntro",
        component: _import("projectIntro/index"),
        meta: {
          menuName: '项目介绍',
          isIndex:1 //是否是菜单页
        },
      },
      {
        path: "/fundIntrduce",
        name: "fundIntrduce",
        component: _import("fundIntrduce/index"),
        meta: {
          menuName: '基金介绍',
          isIndex:1 //是否是菜单页
        },
      },
      {
        path: "/volunteer",
        name: "volunteer",
        component: _import("volunteer/index"),
        meta: {
          menuName: '志愿服务',
          isIndex:1 //是否是菜单页
        },
      },
      {
        path: "/infoOpen",
        name: "infoOpen",
        component: _import("infoOpen/index"),
        meta: {
          menuName: '信息公开',
          isIndex:1 //是否是菜单页
        },
      },
      {
        path: "/partner",
        name: "partner",
        component: _import("partner/index"),
        meta: {
          menuName: '合作伙伴',
          isIndex:1 //是否是菜单页
        },
      },
      {
        path: "/about",
        name: "about",
        component: _import("about/index"),
        meta: {
          menuName: '关于我们',
          isIndex:1 //是否是菜单页
        },
      },
    ],
  },
];
export default routes;
